import { Box } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';
import type { PageFC } from '@salesforce/pwa-kit-react-sdk';
import { Layout } from '../../../components/layout/Layout';
import { Blocks } from '../../../components/sfcc-content-rendering/Blocks';
import { HtmlSnippet } from '../../../components/sfcc-content-rendering/HtmlSnippet';
import { Breadcrumb } from '../../../ui-components';
import { useBreadcrumbs } from '../../../ui-components/breadcrumbs/useBreadcrumbs';
import { canonicalUrlCleanup } from '../../../utils/canonical-url-cleanup';
import { BreadcrumbSchema } from '../../../utils/schema';
import { SearchHead } from '../../search/SearchHead';
import type { CategoryInfo } from '../api/getContentData';

type Props = {
    categoryInfo?: CategoryInfo;
};

const ShowBrandLanding: PageFC<Props> = ({ categoryInfo }: Props) => {
    const category = categoryInfo?.response?.category;
    const breadcrumbs = useBreadcrumbs(category?.parentCategoryTree);
    const location = useLocation();
    return (
        <Layout>
            <SearchHead canonicalUrl={canonicalUrlCleanup(location.pathname)} />
            <Box width="100%" paddingY={4} paddingX={{ base: 4, sm: 8, md: 4 }}>
                <Breadcrumb itemsList={breadcrumbs} />
                <BreadcrumbSchema breadcrumbTrail={breadcrumbs} />
                <div className="shop-by-category">
                    <div className="pt_categorylanding">
                        <div className="dlp-category-listing">
                            <h1 className="h3 brand-head-mrg">
                                <HtmlSnippet
                                    id="shop-by-brand-title"
                                    html={categoryInfo?.response?.category?.c_shopbybrand ?? ''}
                                />
                            </h1>
                            <div className="blp-brand-header">
                                <a href="#brand-link-list-bottom" className="brand-link-list">
                                    <div className="blp-brand-icon-mrg">
                                        <span className="slt-sprite LISTICON" />
                                    </div>
                                    <div className="dlp-brand-a-z">
                                        <FormattedMessage
                                            id="brand.list.A.Z"
                                            defaultMessage="BRAND LIST A-Z"
                                        />
                                    </div>
                                </a>
                            </div>
                            <div className="blp-border" />
                        </div>
                        <Blocks
                            id="brand-cat-landing-1"
                            contentBlocks={categoryInfo?.response?.categoryContent?.categorySlots}
                        />
                        <Blocks
                            id="brand-cat-landing-2"
                            contentBlocks={categoryInfo?.response?.categoryContent?.categorySlots}
                        />
                        <Blocks
                            id="brand-cat-landing-3"
                            contentBlocks={categoryInfo?.response?.categoryContent?.categorySlots}
                        />
                        <Blocks
                            id="brand-cat-landing-4"
                            contentBlocks={categoryInfo?.response?.categoryContent?.categorySlots}
                        />
                        <div id="brand-link-list-bottom">
                            <Blocks
                                id="brand-cat-landing-5"
                                contentBlocks={
                                    categoryInfo?.response?.categoryContent?.categorySlots
                                }
                            />
                        </div>
                        <Blocks
                            id="cat-landing-bottom-block"
                            contentBlocks={categoryInfo?.response?.categoryContent?.categorySlots}
                        />
                        <Blocks
                            id="seo-content-block-js-css"
                            contentBlocks={categoryInfo?.response?.categoryContent?.contentAssets}
                        />
                    </div>
                </div>
            </Box>
        </Layout>
    );
};

ShowBrandLanding.defaultProps = {
    categoryInfo: undefined,
};

export { ShowBrandLanding };
